var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auditInfo"},[_c('div',{staticClass:"auditName"},[_vm._v(" "+_vm._s(_vm.contentName)+" ")]),_c('div',{staticClass:"auditJob"},[_vm._v(_vm._s(_vm.name)+_vm._s(_vm.contentId))])])
}
var staticRenderFns = []

export { render, staticRenderFns }